export const INSIGHTS_BILL_USAGE_ACTIONS = {
    USAGE_BILL_API_ERROR: "USAGE_BILL_API_ERROR",
    USAGE_BILL_DATA_NOT_AVAILABLE: "USAGE_BILL_DATA_NOT_AVAILABLE",
    USAGE_SAVE_YEAR_DATA: "USAGE_SAVE_YEAR_DATA",
    USAGE_SAVE_HOUR_DATA: "USAGE_SAVE_HOUR_DATA",
    USAGE_SAVE_MONTH_DATA: "USAGE_SAVE_MONTH_DATA",
    USAGE_SAVE_DAY_DATA: "USAGE_SAVE_DAY_DATA",
    USAGE_SET_POLLING: "USAGE_SET_POLLING",
    USAGE_SAVE_BILLING_CYCLE_PERIOD: "USAGE_SAVE_BILLING_CYCLE_PERIOD",
    USAGE_CHANGE_MODE: "USAGE_CHANGE_MODE",
    USAGE_CHANGE_GRAPH_STYLE: "USAGE_CHANGE_GRAPH_STYLE",
    USAGE_TOGGLE_FILTER_DROPDOWN: "USAGE_TOGGLE_FILTER_DROPDOWN",
    USAGE_TOGGLE_GAS_ELECTRIC: "USAGE_TOGGLE_GAS_ELECTRIC",
    USAGE_TOGGLE_COST_ENERGY: "USAGE_TOGGLE_COST_ENERGY",
    USAGE_TOGGLE_WEATHER: "USAGE_TOGGLE_WEATHER",
    USAGE_SET_HIGHCHARTS_DATA: "USAGE_SET_HIGHCHARTS_DATA",
    USAGE_CHANGE_YEAR_OFFSET: "USAGE_CHANGE_YEAR_OFFSET",
    USAGE_CHANGE_MONTH_OFFSET: "USAGE_CHANGE_MONTH_OFFSET",
    USAGE_CHANGE_DAY_OFFSET: "USAGE_CHANGE_DAY_OFFSET",
    USAGE_CHANGE_HOUR_OFFSET: "USAGE_CHANGE_HOUR_OFFSET",
    USAGE_SET_ARROW_DISABLED: "USAGE_SET_ARROW_DISABLED",
    USAGE_FETCH_MONTH_FROM_YEAR: "USAGE_FETCH_MONTH_FROM_YEAR",
    USAGE_FETCH_DAY_FROM_MONTH: "USAGE_FETCH_DAY_FROM_MONTH",
    USAGE_FETCH_HOUR_FROM_DAY: "USAGE_FETCH_HOUR_FROM_DAY",
    USAGE_UPDATE_HIGHCHARTS_OBJECT: "USAGE_UPDATE_HIGHCHARTS_OBJECT",
    USAGE_SET_ONGOING_BILLING_CYCLE_DISCLAIMER: "USAGE_SET_ONGOING_BILLING_CYCLE_DISCLAIMER",
    USAGE_SET_ITEMIZATION_UNAVAILABLE_DISCLAIMER: "USAGE_SET_ITEMIZATION_UNAVAILABLE_DISCLAIMER",
    USAGE_SET_MISSING_INTERVAL_DISCLAIMER: "USAGE_SET_MISSING_INTERVAL_DISCLAIMER",
    USAGE_REMOVE_DISCLAIMERS: "USAGE_REMOVE_DISCLAIMERS",
    SET_DISCLAIMERS_VISIBILITY: "SET_DISCLAIMERS_VISIBILITY",
    RESET_DATA: "USAGE_RESET_DATA",
    SET_PROPS_FOR_COST_CONSUMPTION_TOGGLE: "SET_PROPS_FOR_COST_CONSUMPTION_TOGGLE"
};

export function apiError() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_BILL_API_ERROR
    }
}

export function dataNotAvailable(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_BILL_DATA_NOT_AVAILABLE,
        payload: payload
    }
}

export function saveYearData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_YEAR_DATA,
        payload: payload
    }
}

export function saveHourData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_HOUR_DATA,
        payload: payload
    }
}

export function saveMonthData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_MONTH_DATA,
        payload: payload
    }
}

export function saveDayData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_DAY_DATA,
        payload: payload
    }
}

export function saveBillingCyclePeriod(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_BILLING_CYCLE_PERIOD,
        payload: payload
    }
}

export function changeMode(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_MODE,
        payload: payload
    }
}

export function changeGraphStyle(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_GRAPH_STYLE,
        payload: payload
    }
}

export function toggleFilterFropdown(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_FILTER_DROPDOWN,
        payload: payload
    }
}

export function toggleGasElectric(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_GAS_ELECTRIC,
        payload: payload
    }
}

export function toggleCostEnergy(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_COST_ENERGY,
        payload: payload
    }
}

export function toggleWeather(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_WEATHER,
        payload: payload
    }
}

export function setInsightsHighchartsData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_HIGHCHARTS_DATA,
        payload: payload
    }
}

export function changeYearOffset(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_YEAR_OFFSET,
        payload: payload
    }
}

export function changeMonthOffset(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_MONTH_OFFSET,
        payload: payload
    }
}

export function changeDayOffset(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_DAY_OFFSET,
        payload: payload
    }
}

export function changeHourOffset(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_HOUR_OFFSET,
        payload: payload
    }
}

export function setArrowDisabled(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ARROW_DISABLED,
        payload: payload
    }
}

export function fetchMonthBillingCycleFromYear(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_FETCH_MONTH_FROM_YEAR,
        payload: payload
    }
}

export function fetchHourBillingCycleFromDay(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_FETCH_HOUR_FROM_DAY,
        payload: payload
    }
}

export function fetchDayBillingCycleFromMonth(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_FETCH_DAY_FROM_MONTH,
        payload: payload
    }
}

export function setPolling(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_POLLING,
        payload: payload
    }
}

export function updateHighChartsObject(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_UPDATE_HIGHCHARTS_OBJECT,
        payload: payload
    }
}

export function setHasOngoingBillingCycle() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ONGOING_BILLING_CYCLE_DISCLAIMER
    }
}

export function setHasItemizationUnavailable() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ITEMIZATION_UNAVAILABLE_DISCLAIMER
    }
}

export function setHasMissingInterval() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_MISSING_INTERVAL_DISCLAIMER
    }
}

export function removeDisclaimers() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_REMOVE_DISCLAIMERS
    }
}

export function setDisclaimersVisibility(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.SET_DISCLAIMERS_VISIBILITY,
        payload: payload
    }
}

export function setPropsForCostOrConsumptionValues(options) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.SET_PROPS_FOR_COST_CONSUMPTION_TOGGLE,
        payload: options
    }
}